export const environment = {
  production: false,
  // Vazio de propósito: só produção deve capturar no PostHog por enquanto
  // (plano free permite só 1 projeto, então stage e prod ficariam misturados
  // no mesmo projeto se ligado aqui — PosthogService.init() já ignora a
  // inicialização quando posthogKey vem vazio).
  posthogKey: '',
  posthogHost: '',
  apiBaseUrl: 'https://stage-api.slicksell.com.br',
  serverUrl: 'https://stage-api.slicksell.com.br/api',
  paymentGenetatorLinkURL: 'https://stage-api.slicksell.com.br/api',
  serverUrlHostSwoole: 'https://krabo.online:8089/api',
  frontendUrl: 'https://stage.slicksell.link',
  usetifulToken: '84930dcea928318af9a86b5498f4f3a5',
  isWidgetBuild: false,
  forceTokenAuth: false,
  stripePublishableKey: 'pk_test_51SpCsW7tku4TFCkCahFDbvst6UEuhjHCuM2EFIBQ5RE3eoqylEe9pdt6zNHqXQdd16YDIU3aplTpzev75zn85uo400T51XCIBy',
  appBaseUrl: 'https://stage-app.slicksell.com.br',
  shopifyClientId: 'f6a7f7ae9ee49b1b67f43f16abe22e6a',
  nuvemshopAppId: '37144',
};
